import { useEffect } from 'react';

import MarketTrend from '../MarketTrend';

import { Helmet } from "react-helmet";

const MarketTrendHK = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.markettrend.hk = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>Market Trend (HK) - Finetic App</title>
			</Helmet>
			<MarketTrend exchange="HKEX" />
		</>
	);
};

export default MarketTrendHK;
